<template>
	<PortalPage :title="section.label" subtitle="Manage your orders and refills">
		<PortalPlaceholder />
	</PortalPage>
</template>

<script setup lang="ts">
import PortalPage from '@/portal/components/PortalPage.vue'
import PortalPlaceholder from '@/portal/components/PortalPlaceholder.vue'
import { portalSection } from '@/portal/sections'

// The Orders section's outlet page — the placeholder KOVA-797 replaces.
const section = portalSection('orders')
</script>
